
import { updateCardLegendHeight } from "./card-max-height.js";

(function (window, document) {

    //
    // functions
    //
    function moveMenu(source, destination) {
        let dummy = document.createElement('span')
        source.before(dummy)
        destination.before(source)
        dummy.replaceWith(destination)
    }

    function resetMoveMenu() {
        let nav_is_open = document.querySelector('.header-sub-navigation .nav-sections');

        if ( nav_is_open === null ){
            return;
        }

        let navigation_slug = nav_is_open.dataset.nav;

        let nav_move_origine = document.querySelector('.header-sub-navigation .nav-sections');
        let nav_move_destination = document.querySelector('.nav-item[data-nav='+navigation_slug+'] .sub-nav-target');
        moveMenu(nav_move_origine, nav_move_destination);
    }

    function navigationIsOpen(navigation_slug) {

        let nav_is_open = document.querySelector('.nav-item[data-nav='+navigation_slug+'].open');

        return nav_is_open;
    }

    function openNavigation(navigation_slug) {
        // init
        let for_event = document.querySelector('.nav');
        let nav_close = document.querySelectorAll('header .nav-item');
        let nav_open = document.querySelector('.nav-item[data-nav='+navigation_slug+']');
        let nav_backdrop = document.querySelector('.header-backdrop');
        let nav_body_backdrop = document.querySelector('body');

        // close all
        nav_close.forEach(function (nav) {
            nav.classList.remove('open');
        });
        resetMoveMenu();

        // open current
        nav_open.classList.add('open');

        // move menu
        let nav_move_origine = document.querySelector('.nav-item[data-nav='+navigation_slug+'] .nav-sections');
        let nav_move_destination = document.querySelector('.header-sub-navigation .sub-nav-target');
        moveMenu(nav_move_origine, nav_move_destination);

        // display backdrop
        nav_backdrop.classList.add('show');

        // markup for lock scroll
        nav_body_backdrop.classList.add('menu-is-open');
        //nav_body_backdrop.classList.add('menu-mobile-is-open');

        const eventOpen = new CustomEvent('nav-open', {detail: {nav: navigation_slug}});
        for_event.dispatchEvent(eventOpen);

        // height of legend
        requestAnimationFrame(() => {
            setTimeout(() => {
                updateCardLegendHeight();
            }, 50);
        });
    }

    function closeNavigation(navigation_slug) {
        let for_event = document.querySelector('.nav');
        let nav_close = document.querySelectorAll('header .nav-item');
        let nav_backdrop = document.querySelector('.header-backdrop');
        let nav_body_backdrop = document.querySelector('body');
        // close all
        nav_close.forEach(function (nav) {
            nav.classList.remove('open');
        });
        resetMoveMenu();

        // Exclude mobile -> Is button Back
        if( !nav_body_backdrop.classList.contains('menu-mobile-is-open') ){
            nav_backdrop.classList.remove('show');
        }
        nav_body_backdrop.classList.remove('menu-is-open');

        const eventOpen = new CustomEvent('nav-close', {detail: {nav: navigation_slug}});
        for_event.dispatchEvent(eventOpen);
    }

    //
    // Events
    //

    // Toggle Navigation Desktop/Mobile
    let navigation = Array.prototype.slice.call(
        document.querySelectorAll('header .nav-link[data-nav]')
    );

    navigation.forEach(function (navigation) {

        navigation.addEventListener('click', function(event) {
            // cancel native click
            event.preventDefault();

            let navigation_slug = navigation.dataset.nav;
            let nav_backdrop = document.querySelector('.header-backdrop');
            let nav_body_backdrop = document.querySelector('body');
            let nav_search_input = document.querySelector('.block-search .form-control');

            // Open/Close
            if ( navigationIsOpen(navigation_slug) === null ){
                openNavigation(navigation_slug);

                // display backdrop
                nav_backdrop.classList.add('show');

                // Focus on search input
                if(navigation_slug == 'nav-search' && nav_search_input){
                    nav_search_input.focus();
                };

            } else {

                closeNavigation(navigation_slug);

                if(nav_search_input){
                    nav_search_input.blur();
                };
            }

        });

    });

    // Open Navigation Mobile 1st level
    let navigation_mobile = Array.prototype.slice.call(
        document.querySelectorAll('.navJsMobileOpen')
    );

    navigation_mobile.forEach(function (navigation_mobile) {
        navigation_mobile.addEventListener('click', function(event) {

            let nav_backdrop = document.querySelector('.header-backdrop');
            let nav_body_backdrop = document.querySelector('body');

            // display backdrop
            nav_backdrop.classList.add('show');

            // markup for lock scroll + mobile state
            nav_body_backdrop.classList.add('menu-mobile-is-open');
        });
    });

    // Close Navigation Mobile 1st level
    let btn_close_parent = Array.prototype.slice.call(
        document.querySelectorAll('.navJsMobileClose')
    );
    btn_close_parent.forEach(function (btn_close_parent) {

        btn_close_parent.addEventListener('click', function(event) {
            let nav_body_backdrop = document.querySelector('body');
            nav_body_backdrop.classList.remove('menu-mobile-is-open');
            let navToClose = resolveCurrentSubNav();
            closeNavigation(navToClose);
        });

    });

    const resolveCurrentSubNav = () => {
        let navToClose = null;
        let subNavElm = document.querySelector('.header-sub-navigation');
        if(subNavElm) {
            let nav = subNavElm.querySelector('.nav-sections');
            if(nav) {
                navToClose = nav.dataset.nav;
            }
        }
        return navToClose;
    }

    document.addEventListener('DOMContentLoaded', ()=>{
        // Close Navigation Desktop 2nd level
        let btn_close = Array.prototype.slice.call(
            document.querySelectorAll('.navJsClose')
        );
        btn_close.forEach(function (btn_close) {

            btn_close.addEventListener('click', function (event) {
                let navToClose = resolveCurrentSubNav();
                closeNavigation(navToClose);
            });

        });
    })

    // Close navigation by click outside
    let nav_backdrop = document.querySelector('.header-backdrop');

    nav_backdrop?.addEventListener('click', function(event) {
        let nav_body_backdrop = document.querySelector('body');
        nav_body_backdrop.classList.remove('menu-mobile-is-open');
        let navToClose = resolveCurrentSubNav();
        closeNavigation(navToClose);
    });

    // Close navigation by click on link
    document.querySelectorAll('.nav-cards-item').forEach(function (link) {
        link.addEventListener('click', function(event) {
            let nav_body_backdrop = document.querySelector('body');
            nav_body_backdrop.classList.remove('menu-mobile-is-open');
            let navToClose = resolveCurrentSubNav();
            closeNavigation(navToClose);
        });
    });

    // Close navigation when clicking on dynamic search results
    document.addEventListener('click', function (event) {
        let searchLink = event.target.closest('.search-result');
        if (searchLink) {
            let nav_body_backdrop = document.querySelector('body');
            nav_body_backdrop.classList.remove('menu-mobile-is-open');
            let navToClose = resolveCurrentSubNav();
            closeNavigation(navToClose);
        }
    });

    // Scrollbar width
    let scroll_width = (window.innerWidth - document.body.clientWidth);
    let dom_header = document.querySelector('header');
    dom_header?.style.setProperty('--nautil-scroll-width', scroll_width + 'px');


})(window, document);

// Add sticky when is enabled
window.addEventListener('scroll', function() {

    const header = document.querySelector('.header');
    const stickyThreshold = 200;
    const unstickyThreshold = 150;
    let scrollPosition = window.scrollY;
    let ticking = false;

    if (!ticking) {
        window.requestAnimationFrame(function() {
            let scrollPosition = window.scrollY;

            if (scrollPosition >= stickyThreshold && !header.classList.contains('sticky-enable')) {
                header.classList.add('sticky-enable');
            } else if (scrollPosition < unstickyThreshold && header.classList.contains('sticky-enable')) {
                header.classList.remove('sticky-enable');
            }

            ticking = false;
        });
        ticking = true;
    }

});
